import { ALREADY_REGISTERED_EMAIL, INVALID_CODE, SOMETHING_WENT_WRONG } from 'constants/onboarding';

type ErrorTextMap = { [key: number]: string };

export const errorTextMap: ErrorTextMap = {
    4000006: 'Oops! The email address or password you entered is invalid.',
    4000002: 'Property email is missing.',
    4060005: SOMETHING_WENT_WRONG,
    4070005: SOMETHING_WENT_WRONG,
    4000028: ALREADY_REGISTERED_EMAIL,
    4000007: ALREADY_REGISTERED_EMAIL,
    4060006: INVALID_CODE,
    4070006: INVALID_CODE
};
